import { useEffect } from 'react'
import useGetUserProfile from '../../common/category/useGetUserProfile'
import { PanelContainer } from '../../common/panel/PanelContainer'
import SideBarUserManagement from '../SideBarUserManagement'
import { Title } from '../Title'
import { AvailablePackage } from './availablePackage'
import { DisplayPopupResult } from './common/popupActivateResult'
import { DisplayPopupBuyPackage } from './common/popupBuyPackage/DisplayPopupBuyPackage'
import { OrderManagement } from './orderManagement'
import { PackageSubscriptionManagement } from './packageSubManagement'
import { YourSubscription } from './yourSubscription'
import { useDispatch } from 'react-redux'
import { getIsAvailableToAddNewSubscription } from './store/thunk'

export const SubscriptionPayment = () => {
  const dispatch = useDispatch()
  const { loading } = useGetUserProfile()

  useEffect(() => {
    dispatch(getIsAvailableToAddNewSubscription())
  }, [])

  return (
    <SideBarUserManagement
      renderTopComponent={() => <Title text="subscriptionPayment.TITLE" />}
      renderBottomComponent={() => (
        <>
          <YourSubscription />
          <PanelContainer>
            <AvailablePackage />
            <PackageSubscriptionManagement />
            <OrderManagement />
            <DisplayPopupResult />
            <DisplayPopupBuyPackage />
          </PanelContainer>
        </>
      )}
      isLoadingContent={loading}
    />
  )
}
